export const notNull = <T>(value: T | null | undefined, key: string): T => {
    if (value == null) {
        throw new Error(`'${key}' must not be "null" or "undefined".`);
    }

    return value;
};
